function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.03 22h-7.04a.749.749 0 110-1.5h7.04a.749.749 0 110 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.41 16.34l-4.75 4.75a3.027 3.027 0 01-4.07.18c-.07-.06-.13-.12-.19-.18l-.87-.87-1.79-1.79-.86-.86c-.07-.07-.13-.14-.19-.21a3.01 3.01 0 01.19-4.04l3.69-3.68 1.06-1.06 7.78 7.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.12 10.64l-5.71 5.7-7.78-7.76 5.71-5.7a3.024 3.024 0 014.26 0l3.52 3.51a3.012 3.012 0 010 4.25z"
})));